import { useFetcher } from "~/hooks/useFetcher";
import { FILE_BROWSER_API } from "~/lib/fileBrowserApi";

type AccessLevel = "read" | "write";

const useFilePermissions = () => {
  return useFetcher<Record<string, AccessLevel[]>>(`${FILE_BROWSER_API}/permissions`, {
    keepPreviousData: true,
  });
};

export default useFilePermissions;
